import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import {  updateLLMScheduledPrompt } from "../graphql/mutations";
import {
  UpdateLLMScheduledPromptInput,
  UpdateLLMScheduledPromptMutation,
} from "../API";

export async function updateLLMScheduledPromptAfterEdit(
  values: UpdateLLMScheduledPromptInput
): Promise<GraphQLResult<UpdateLLMScheduledPromptMutation>> {

  console.log("updateLLMScheduledPromptAfterEdit", values);

  return API.graphql(
    graphqlOperation(updateLLMScheduledPrompt, {
      input: {
        id: values.id,
        projectId: values.projectId,
        status: values.status,
        agentId: values.agentId,
        title: values.title,
        data: values.data,
        prompt: values.prompt,
        scheduledAt: values.scheduledAt,
        repeatIntervalHours: values.repeatIntervalHours ?? undefined,
        followOnAgentId: values.followOnAgentId ?? undefined,
        followOnFollowOnAgentId: values.followOnFollowOnAgentId ?? undefined,
        followOnTitle: values.followOnTitle ?? undefined,
        followOnPrompt: values.followOnPrompt ?? undefined,
        followOnScheduledAtHours: values.followOnScheduledAtHours ?? undefined,
        followOnNotificationEmailAddresses: values.followOnNotificationEmailAddresses ?? undefined,
        followOnNotificationEmailSubject: values.followOnNotificationEmailSubject ?? undefined,
        followOnRepeatIntervalHours: values.followOnRepeatIntervalHours ?? undefined,
        notificationEmailAddresses: values.notificationEmailAddresses ?? undefined,
        notificationEmailSubject: values.notificationEmailSubject ?? undefined,

      },
    })
  ) as Promise<GraphQLResult<UpdateLLMScheduledPromptMutation>>;
}
